// src/features/executive/insight/hooks/use-revenue-by-channel.ts
import { useExecutiveQuery } from 'features/executive/shared/hooks/use-executive-query'
import InsightApi from 'api/executive/insight.api'
import type {
  GetInsightRevenueByChannelParams,
  InsightRevenueByChannelResponse,
  RevenueMode,
} from 'api/executive/executive.types'

export function useRevenueByChannel(revenueMode?: RevenueMode) {
  return useExecutiveQuery<
    GetInsightRevenueByChannelParams,
    InsightRevenueByChannelResponse
  >(
    'insight.revenue-by-channel',
    InsightApi.getRevenueByChannel,
    (f) => {
      if (!f.dateRange?.start || !f.dateRange?.end) return null
      return {
        dateFrom: f.dateRange.start,
        dateTo: f.dateRange.end,
        branchId: f.branchId ?? undefined,
        doctorId: f.doctorId ?? undefined,
        patientType: f.patientType ?? undefined,
        nationality: f.nationality ?? undefined,
        sourceChannel: f.sourceChannel ?? undefined,
        promotionId: f.promotionId ?? undefined,
        revenueMode,
      }
    },
    { extraKey: revenueMode }
  )
}
